// necessary set
import { flow, makeObservable, observable } from 'mobx'

// need tool or method
import BaseDataService from '@common/BaseDataService'
import { CH_USER_API } from '@common/Define'
import RootStore from '@store/RootStore'

// Param type
import { ICategoryFaram } from '@common/ParamType'

// Data type
import { IMainData, ICategoryListData } from '@common/DataType'

/**
 * @author cardo
 * @description
 * cardo-home : MainStore
 */
export class MainStore extends BaseDataService {
    rootStore: RootStore
    mainDoorData: IMainData | undefined
    categoryData: ICategoryListData[] | undefined
    categoryMainData: IMainData | undefined
    // hotwalletAllData: { list: IHotWalletAllData[]; count: number } = { list: [], count: 0 }
    constructor(rootStore: RootStore) {
        super()
        this.rootStore = rootStore
        makeObservable(this, {
            // getHotWalletAll: flow,
            // hotwalletAllData: observable,
            getMainDoor: flow,
            mainDoorData: observable,
            categoryData: observable,
            categoryMainData: observable,
        })
    }

    *getMainDoor() {
        try {
            this.mainDoorData = yield super.getAPI(CH_USER_API.homeAPI)
        } catch (error) {
            return 'error'
        }
    }
}
